<template>
  <div>
    <button @click="text = piece.content" type="button" data-toggle="modal" :data-target="'#smartText' + this.piece.id" tabindex="-1" class="btn btn-sm btn-primary mt-2" aria-disabled="false">
    <span>
      <svg
          focusable="false"
          data-prefix="fas"
          data-icon="wand-magic-sparkles"
          class="svg-inline--fa fa-wand-magic-sparkles mr-2"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
          style="height: 10px"
          color="#FFF">
            <path fill="currentColor"
                  d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"></path>
      </svg>
    </span>
      <span class="tox-tbtn__select-label">Smart Text</span>
    </button>
    <div
        class="modal fade"
        :id="'smartText' + this.piece.id"
        role="dialog"
        :aria-labelledby="'smartText' + this.piece.id"
        aria-hidden="true"
        data-backdrop="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Smart Text</h4>
          </div>
          <div class="modal-body">
            <span v-if="textLoading" class="loader"></span>
            <div v-else>
              <shared-step-editor-textarea-field
                  :input-value="text"
                  :maxlength="limits[piece.name]"
                  :height="40"
                  :error="text.length < 1 ? `Shouldn't be empty` : ''"
                  :label="normalizedName(piece.name)"
                  error-position="absolute"
                  responsive
                  class="social-step-editor-sidebar-text__textarea mb-5"
                  @input="onInput"
              />
              <div class="row mb-2">
                <div class="col-sm-4">
                  <button class="btn btn-block btn-sm btn-primary" :disabled="disabled" @click="smartText('fix', text)">Fix Spelling & Grammar</button>
                </div>
                <div class="col-sm-4">
                  <button class="btn btn-block btn-sm btn-primary" :disabled="disabled" @click="smartText('expand', text)">Expand Text</button>
                </div>
                <div class="col-sm-4">
                  <button class="btn btn-block btn-sm btn-primary" :disabled="disabled" @click="smartText('summarize', text)">Summarize Text</button>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-sm-4">
                  <button class="btn btn-block btn-sm btn-primary" :disabled="disabled" @click="smartText('rephrase', text)">Rephrase Text</button>
                </div>
                <div class="col-sm-4">
                  <button class="btn btn-block btn-sm btn-primary" :disabled="disabled" @click="smartText('friendly', text)">Make it Friendly</button>
                </div>
                <div class="col-sm-4">
                  <button class="btn btn-block btn-sm btn-primary" :disabled="disabled" @click="smartText('formal', text)">Make it Formal</button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!textLoading" class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            <button
                @click="save"
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
            >
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import {SocialPostPieceNames} from "../../social/SocialPostPieceNames";
import {SocialPostTypes} from "../../social/SocialPostTypes";
import SharedStepEditorTextareaField from "./SharedStepEditorTextareaField.vue"
import SharedStepEditorInputCounter from "./SharedStepEditorInputCounter.vue";

export default {
  components: {SharedStepEditorTextareaField, SharedStepEditorInputCounter},
  props: {
    piece: Object,
  },
  mounted() {
    this.text = this.piece.content;
  },
  data() {
    return {
      textLoading: false,
      text: '',
    }
  },
  methods: {
    onInput(input) {
      this.text = input;
    },
    save() {
      this.piece.content = this.text;
    },
    normalizedName(name) {
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
    smartText(action, text) {
      this.textLoading = true;
      axios.post(`/api/?entity=smart-text&action=${action}SmartText`, { text })
        .then((result) => {
          if (result.status === 200 && result.data.text) {
            this.text = result.data.text;
          } else {
            swal.fire({
              title: 'UhOh!',
              text: 'Something went wrong.',
              type: 'error',
              confirmButtonText: 'Ok',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-lg btn-primary',
            });
          }
          this.textLoading = false;
        });
    }
  },
  computed: {
    enabledPiecesInAdvance() {
      return [SocialPostPieceNames.PersonalMessage, SocialPostPieceNames.Message];
    },
    messageLimit() {
      switch (this.activityType) {
        case SocialPostTypes.FacebookPagePosts:
        case SocialPostTypes.FacebookPersonalPosts:
          return 63206;
        case SocialPostTypes.LinkedInPersonalPosts:
          return 1300;
        case SocialPostTypes.TwitterPersonalPosts:
          return 280;
        default:
          return undefined;
      }
    },
    limits() {
      return {
        [SocialPostPieceNames.Title]: 80,
        [SocialPostPieceNames.CallToAction]: 80,
        [SocialPostPieceNames.Description]: 200,
        [SocialPostPieceNames.Caption]: 200,
        [SocialPostPieceNames.Message]: this.messageLimit,
        [SocialPostPieceNames.PersonalMessage]: this.messageLimit,
      };
    },
    disabled() {
      return !this.text || this.text.length === 0;
    }
  },
};
</script>

<style scoped>
.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #66CCCC;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>